import { TreeNode } from 'primeng/api';
import { Roll } from '@app/models/knitting/roll';

export interface TransferReportOption {
  label: string;
  entityId: string;
  entityType: string;
  transferType: string;
}

export interface TransferUnitTreeNode extends TreeNode {
  data: {
    transferUnitNumber?: string;
    number?: string;
    expectedFabricCode?: string;
    itemCode?: string;
    itemName?: string;
    fabricForm?: string;
    knittingOrderNumber?: string;
    currentWeight?: number;
    currentWeightKg?: number;
    currentWeightYards?: number;
    type: 'transferUnit' | 'roll';
    rollNumber?: string;
    transferUnit?: string;
  };
}

export type TransferUnitRollMap = Record<string, Roll[]>;

/** Parent-row aggregation: numeric fields are totals, string fields are distinct values comma-joined. */
export interface AggregatedRollData {
  expectedFabricCode: string;
  itemCode: string;
  itemName: string;
  fabricForm: string;
  knittingOrderNumber: string;
  currentWeight: number;
  currentWeightKg: number;
  currentWeightYards: number;
}

export enum MoveToBatchWorkOrderView {
  CurrentWorkOrder = 0,
  OtherWorkOrder = 1,
}
